import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLedgerSummary } from '../../../api/LedgerAPI';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';

import { getAvatar } from '../../../commonfunctions';
import AppPaginator from '../../AppPaginator';
import PerPageBlock from '../../common/PerPageBlock';
import AppSearchBox from '../../AppSearchBox';


const MemberLedgersPage = () => {
    const navigate = useNavigate();
      const [currentPage, setCurrentPage] = useState(1);
        const [perPage, setPerPage] = useState(15);
         const [searchTerm, setSearchTerm] = useState('');
            const [searchTermCompleted, setSearchTermCompleted] = useState('');
    const [summaryList, setSummaryList] = useState({ data: [], last_page: 0 });
    const [isLoading, setIsLoading] = useState(true);
    // ... state for pagination and search

    useEffect(() => {
        setIsLoading(true);
         const filters = { page: currentPage, per_page: perPage, search_term: searchTermCompleted };
        getLedgerSummary(filters, (response) => {
            setIsLoading(false);
            if (response.ledger_summary) {
                setSummaryList(response.ledger_summary);
            }
        });
    }, [currentPage, perPage, searchTermCompleted]);

    const handleViewLedger = (userId) => {
        navigate(`/club_portal/financials/ledgers/${userId}`);
    };

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="Member Ledgers" />
                <div className="row">

                      <AppSearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchTermCompleted={setSearchTermCompleted} />

                    <div className="d-flex m-md-3">
                                {summaryList.data.length > 0 && (
                                    <>
                                        <AppPaginator totalPages={summaryList.last_page} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                                        <PerPageBlock perPage={perPage} setPerPage={setPerPage} />
                                    </>
                                )}
                                {isLoading && <div className="loader_box ms-auto"><div className="loader_14"></div></div>}
                            </div>

                    {/* ... Search and Pagination UI ... */}
                    {!isLoading && summaryList.data.map(user => {
                        const balance = user.latest_wallet_transaction?.balance_after_transaction || '0.00';
                        const balanceColor = balance < 0 ? 'text-danger' : 'text-success';
                        return (
                            <div className="col-md-6 col-xl-4 project-card" key={user.id}>
                                <div className="card hover-effect">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <img src={getAvatar(user.profile_pic_path)} alt={user.name} className="rounded-circle me-3" width="50" height="50" />
                                            <div className="flex-grow-1">
                                                <h6 className="m-0 text-dark f-w-600">{user.name}</h6>
                                                <p className="m-0 text-muted">Current Balance: <strong className={balanceColor}>₹{balance}</strong></p>
                                            </div>
                                            <button className="btn btn-primary btn-sm" onClick={() => handleViewLedger(user.id)}>View</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                </div>
            </div>
        </main>
    );
};

export default MemberLedgersPage;
